import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import InviteAgentForm from "@/components/Agents/Add/component";
import { checkAuthorizationByRoles } from "@/helpers/authorization";
import { useMe } from "@/hooks/session/useMe";

const InviteAgent = () => {
  const { data: meData, isLoading } = useMe();
  const router = useNavigate();

  useEffect(() => {
    if (
      !isLoading &&
      !meData?.AccountsMsMe.supportUserInfo.rights?.includes("SUPER_AGENT")
    ) {
      router({ to: "/" });
    }
  }, [meData, isLoading, router]);

  return (
    <div>
      <InviteAgentForm />
    </div>
  );
};

export const Route = createFileRoute("/backoffice-users/add/")({
  beforeLoad: async ({ context }) => {
    checkAuthorizationByRoles(context.roles);
  },
  component: InviteAgent,
});
